import React from 'react';
import { ShieldCheck, Globe2, FileCheck2, BarChart3 } from 'lucide-react';
import Reveal from '@/components/Reveal';

const SIGNALS = [
  { icon: ShieldCheck, k: 'Exclusive Representation', v: 'Every creator contracted directly' },
  { icon: Globe2, k: 'London & Cape Town', v: 'Dual-office global coverage' },
  { icon: FileCheck2, k: 'Full Usage Licensing', v: 'Rights documented on every asset' },
  { icon: BarChart3, k: 'Verified Reporting', v: 'Platform-native performance data' },
];

export default function TrustBar() {
  return (
    <section className="bg-[#0B0B0B] border-y border-white/10">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10 py-10 lg:py-12">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          {SIGNALS.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.k} delay={i * 0.08}>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-lg bg-[#2563EB]/12 border border-[#3B82F6]/25 flex items-center justify-center shrink-0">
                    <Icon className="w-[18px] h-[18px] text-[#3B82F6]" />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-white leading-snug">{s.k}</p>
                    <p className="text-xs text-white/45 mt-1 leading-relaxed">{s.v}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}